import {createContext} from "react";
import * as api from "./mappings/HttpApiMapping"

const apiContext = createContext(api);
export {apiContext};
